import { Typography } from "@mui/material";
import React from "react";
import { StoreData } from "../../Objects/StoreInterface";

interface StoreLoginNameProps {
    storeData: StoreData
    variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "inherit" | undefined
}

const StoreLoginName: React.FC<StoreLoginNameProps> = ({
    storeData,
    variant
}) => {
    return (
        <>
            <Typography
                variant={variant}
            >
                {storeData.str_login_str}
            </Typography>
        </>
    );
}

export default StoreLoginName